@import '../../sass/components/form-field';

som-textarea {
  .textarea-container {
    position: relative;

    textarea {
      padding-bottom: 1.5rem;
    }

    .max-nb-chars {
      position: absolute;
      right: 0.75rem;
      bottom: 0.5rem;
      text-align: right;
      font-size: 0.6875rem;
    }
  }
}
